module.exports = __webpack_public_path__ + "static/media/holiday-gift-card-dt-en.10277bfc.jpg";